import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Component({
	selector: 'NgxToggleColumn',
	templateUrl: './ngxToggleColumn.component.html'
})
export class NgxToggleColumn {
	@Input() columns = [];
	@Output() columnToggle = new EventEmitter();

	constructor() {

	}

	ngOnInit() {

	}

	/*ngOnChanges(changes: SimpleChanges) {
		this.columns = changes.columns.currentValue;
	}*/

	onShowColToggle() {
		let isCheckedColFnd = _.find(this.columns, 'checked');
		if (_.isEmpty(isCheckedColFnd)){
			this.columns = _.map(this.columns, o => _.extend({ checked: true }, o));
		}

		//this.refreshPage.emit();
	}

	onChangeColToggle(col) {
		let showCol = _.filter(this.columns, { checked: true });
		this.columnToggle.emit(showCol);
	}
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/shared/ngxGrid/ngxToggleColumn.component.ts